// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39jsf","title":"styles_title__BBUxt"};